export default {
  // Inventory-related translations
  "no_films_found": "No films found matching",
  "no_films_yet": "You don't have any rolls of film yet",
  "add_first_film": "Add Your First Film",
  "no_lenses_found": "No lenses found matching",
  "no_lenses_yet": "You don't have any lenses yet",
  "add_first_lens": "Add Your First Lens",
  "no_cameras_found": "No cameras found matching",
  "no_cameras_yet": "You don't have any cameras yet",
  "add_first_camera": "Add Your First Camera",
  "no_items_inventory": "No items in your inventory",
  "inventory_management": "Inventory Management",
  "film": "Film",
  "cameras": "Cameras",
  "lenses": "Lenses",
  "search_films": "Search films...",
  "search_lenses": "Search lenses...",
  "search_cameras": "Search cameras...",
  "add_lens": "Add Lens",
  "add_film": "Add Film",
  "add_camera": "Add Camera",
  "add_new_lens": "Add New Lens",
  "add_new_film": "Add New Film",
  "add_new_camera": "Add New Camera",
  "add_lens_details": "Fill in the details below to add a new lens to your inventory.",
  "add_film_details": "Fill in the details below to add a new film to your inventory.",
  "add_camera_details": "Fill in the details below to add a new camera to your inventory.",
  "essential_info": "Essential Info",
  "optional_details": "Optional Details",
  "lens_name": "Lens Name/Model",
  "lens_name_placeholder": "50mm f/1.8, 24-70mm f/2.8, etc.",
  "brand_placeholder": "Nikon, Canon, etc.",
  "film_name": "Film Name",
  "film_name_placeholder": "Portra 400, HP5 Plus, etc.",
  "film_brand_placeholder": "Kodak, Fujifilm, Ilford, CineStill, etc.",
  "camera_name": "Camera Name/Model",
  "camera_name_placeholder": "AE-1, F3, Leica M6, etc.",
  "mount": "mount",
  "Mount": "Mount",
  "mount_placeholder": "e.g. EF, M42",
  "mount_description": "Max 4 alphanumeric characters (e.g., EF, M42)",
  "status": "Status",
  "select_status": "Select status",
  "working": "Working",
  "needs_repair": "Needs Repair",
  "for_parts": "For Parts",
  "serial_number": "Serial Number (Optional)",
  "purchase_date": "Purchase Date (Optional)",
  "purchase_price": "Purchase Price (Optional)",
  "notes_placeholder": "Any additional notes about this item",
  "next_step": "Next Step",
  "update_lens": "Update Lens",
  "update_film": "Update Film",
  "update_camera": "Update Camera",
  "edit_film": "Edit Film",
  "edit_lens": "Edit Lens",
  "edit_camera": "Edit Camera",
  "update_film_details": "Update your film details below",
  "update_lens_details": "Update your lens details below",
  "update_camera_details": "Update your camera details below",
  "delete_film": "Delete Film",
  "delete_lens": "Delete Lens",
  "delete_camera": "Delete Camera",
  "confirm_delete_film": "Are you sure you want to delete",
  "from_your_inventory": "from your inventory",
  "action_cannot_undone": "This action cannot be undone.",
  "film_removed_inventory": "Film removed from inventory",
  "lens_removed_inventory": "Lens removed from inventory",
  "camera_removed_inventory": "Camera removed from inventory",
  "failed_delete_film": "Failed to delete film",
  "failed_delete_lens": "Failed to delete lens",
  "failed_delete_camera": "Failed to delete camera",
  "cannot_delete_film_missing_id": "Cannot delete film, missing ID",
  "cannot_delete_lens_missing_id": "Cannot delete lens, missing ID",
  "cannot_delete_camera_missing_id": "Cannot delete camera, missing ID",
  "film_updated_successfully": "Film updated successfully",
  "lens_updated_successfully": "Lens updated successfully",
  "camera_updated_successfully": "Camera updated successfully",
  "error_updating_film": "Error updating film",
  "error_updating_lens": "Error updating lens",
  "error_updating_camera": "Error updating camera",
  "cannot_update_film_missing_id": "Cannot update film, missing ID",
  "cannot_update_lens_missing_id": "Cannot update lens, missing ID",
  "cannot_update_camera_missing_id": "Cannot update camera, missing ID",
  "all": "All",
  "all_film": "All Film",
  "all_lenses": "All Lenses",
  "all_cameras": "All Cameras",
  "unexposed": "Unexposed",
  "fresh": "Fresh",
  "exposed": "Exposed",
  "expired": "Expired",
  "developed": "Developed",
  "transferring": "Transferring:",
  "quantity_expose": "Quantity to expose",
  "notes_optional": "Notes (optional)",
  "mark_exposed": "Mark as Exposed",
  "mark_film_exposed": "Mark Film as Exposed",
  "transfer_film_description": "Transfer film from your inventory to your exposed collection.",
  "signin_required_inventory": "You must be signed in to view your inventory",
  "film_details": "Film Details",
  "lens_details": "Lens Details",
  "camera_details": "Camera Details",
  "last_updated": "Last updated",
  "quantity": "Quantity",
  "expiration_date": "Expiration Date",
  "not_applicable": "N/A",
  "invalid_date": "Invalid date",
  "qty": "Qty",
  "expiration": "Expiration",
  "view_details": "View Details",
  "sort_by": "Sort by",
  "filter_by": "Filter by",
  "ascending": "Ascending",
  "descending": "Descending",
  "date_added": "Date Added",
  "focal_length": "Focal Length",
  "aperture": "Aperture",
  "iso": "ISO",
  "film_type": "Film Type",
  "color": "Color",
  "black_and_white": "Black & White",
  "slide": "Slide",
  "camera_type": "Camera Type",
  "slr": "SLR",
  "dslr": "DSLR",
  "mirrorless": "Mirrorless",
  "rangefinder": "Rangefinder",
  "point_and_shoot": "Point & Shoot",
  "instant_film": "Instant Film",
  "error_loading_cameras": "Error loading cameras",
  "camera_added_successfully": "Camera added successfully",
  "error_adding_camera": "Error adding camera",
  "select_format": "Select format",
  "select_camera_type": "Select camera type",
  "compatible_cameras": "Compatible Cameras",
  "compatible_lenses": "Compatible Lenses",
  "compatible_films": "Compatible Films",
  "back_to_lenses": "Back to Lenses",
  "back_to_cameras": "Back to Cameras",
  "failed_load_lens": "Failed to load lens details",
  "lens_not_found": "Lens not found",
  "are_you_absolutely_sure": "Are you absolutely sure?",
  "brand": "Brand",
  "model": "Model", 
  "type": "Type",
  "notes": "Notes",
  "medium_format": "Medium Format",
  "large_format": "Large Format",
  "format": "format",
  "Format": "Format",
  "back": "Back"
};
